<div class="wrapper">
  <div class="container">
    <div class="page-header">
      <h1 class="heading">メンバー一覧</h1>
    </div>
    <div class="search-box">
      <app-search-input
        [value]="this.queryName$ | async"
        (changed)="this.queryNameChange($event)"
        [placeholder]="'名前で検索'"
      ></app-search-input>
      <app-select
        class="select-department"
        [options]="this.selectableDepartments"
        (selectedOptionChange)="this.departmentSelected($event)"
      ></app-select>
      @if (isRoleplayEnabled) {
        <app-select
          class="select-month"
          [options]="this.monthOptions"
          [selectedOption]="this.selectedMonth"
          (selectedOptionChange)="this.monthSelected($event)"
        ></app-select>
      }
    </div>
    <div
      #tableContainer
      class="table-container"
      infiniteScroll
      [scrollWindow]="false"
      (scrolled)="loadMoreUsers()"
    >
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="sortable"
            (click)="this.sort('name')"
          >
            名前
            @if (this.sortField === 'name') {
              {{ this.sortDirection === 'asc' ? '▲' : '▼' }}
            }
          </th>
          <td mat-cell *matCellDef="let user">{{ user.name }}</td>
        </ng-container>

        <ng-container matColumnDef="department">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="sortable"
            (click)="this.sort('departmentName')"
          >
            部署
            @if (this.sortField === 'departmentName') {
              {{ this.sortDirection === 'asc' ? '▲' : '▼' }}
            }
          </th>
          <td mat-cell *matCellDef="let user">{{ user.department }}</td>
        </ng-container>

        <ng-container matColumnDef="latestBusinessMeetingName">
          <th mat-header-cell *matHeaderCellDef>最新商談</th>
          <td mat-cell *matCellDef="let user">
            {{ user.latestBusinessMeetingName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="latestBusinessMeetingDate">
          <th mat-header-cell *matHeaderCellDef>最新商談日</th>
          <td mat-cell *matCellDef="let user">
            {{
              user.latestBusinessMeetingDate
                ? (user.latestBusinessMeetingDate | date: 'yyyy/MM/dd')
                : ''
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="roleplayCount">
          <th mat-header-cell *matHeaderCellDef>ロールプレイ回数</th>
          <td mat-cell *matCellDef="let user">{{ user.roleplayCount }}回</td>
        </ng-container>

        <ng-container matColumnDef="dashboardLink">
          <th mat-header-cell *matHeaderCellDef>スコア推移</th>
          <td mat-cell *matCellDef="let user">
            <a
              rectangle
              [routerLink]="['/dashboard', 'individual']"
              [queryParams]="{ 'user-id': user.id }"
            >
              参照
            </a>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="navigateToUserDetail(row.id)"
        ></tr>
      </table>
      <app-loading [showLoading]="this.loading"></app-loading>
      @if (this.dataSource.length === 0 && !this.loading) {
        <div class="empty">該当なし</div>
      }
    </div>
  </div>
</div>
